import React from "react";
import SingleQuestionList from "../Components/SingleQuestionList/SingleQuestionList";

const SingleQuestionListPage = () => {
  return <SingleQuestionList />;
};

export default SingleQuestionListPage;
